import Icon from '../components/Icon.vue'

Icon.register({
  'mug-hot': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M127.1 146.5C128.4 154.2 135.1 160 143.1 160H159.6C169.4 160 177.2 151.5 175.9 142 172.1 113.8 159.5 87.8 139.3 67.3 124.9 52.6 115.7 34 112.9 13.8 111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18 68 49.9 82.1 79.3 104.7 102.4 116.7 114.6 124.4 129.9 127.1 146.5zM239.1 146.5C240.4 154.2 247.1 160 255.1 160H271.6C281.4 160 289.2 151.5 287.9 142 284.1 113.8 271.5 87.8 251.3 67.3 236.9 52.6 227.7 34 224.9 13.8 223.8 5.9 217 0 208.8 0H192.4C182.6 0 174.9 8.5 176.1 18 180 49.9 194.1 79.3 216.7 102.4 228.7 114.6 236.4 129.9 239.1 146.5zM400 192H32C14.3 192 0 206.3 0 224V416C0 469 43 512 96 512H288C341 512 384 469 384 416H400C461.8 416 512 365.8 512 304S461.8 192 400 192zM400 352H384V256H400C426.5 256 448 277.5 448 304S426.5 352 400 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mug-hot.js
// module id = gs9v
// module chunks = 144